import type { Dict } from '../types';
import { en } from './en';

export const hi: Dict = en;
